import { render, staticRenderFns } from "./table-buttons.vue?vue&type=template&id=e74be97c&"
import script from "./table-buttons.vue?vue&type=script&lang=js&"
export * from "./table-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports